import { HttpStatusCode } from '@angular/common/http';
import { Component, ViewChild, inject, signal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CountdownTimerComponent } from '@components/countdown/countdown-timer/countdown-timer.component';
import { SnackbarService, SnackbarType } from '@shared/helper/snackbar.service';
import { GeneralService } from '@shared/services/general.service';
import { TokenService } from '@shared/services/token.service';
import { UserService } from '@shared/services/user.service';
import { CodeInputComponent, CodeInputModule } from 'angular-code-input';

@Component({
  selector: 'app-confirm-parental-control-dialog',
  imports: [MatDialogModule, CodeInputModule, CountdownTimerComponent, MatButtonModule],
  providers: [UserService],
  templateUrl: './confirm-parental-control-dialog.component.html',
  styleUrls: ['./confirm-parental-control-dialog.component.scss'],
})
export class ConfirmParentalControlDialogComponent {
  @ViewChild('codeInputRef') codeInputRef!: CodeInputComponent;
  codeInput = new FormControl('', [Validators.required]);
  expiredTime = signal(false);
  data = inject(MAT_DIALOG_DATA);

  public tokenService = inject(TokenService);
  private readonly generalService = inject(GeneralService);
  private readonly userService = inject(UserService);
  private readonly dialogRef = inject(MatDialogRef<ConfirmParentalControlDialogComponent>);
  private readonly snackbar = inject(SnackbarService);

  ngOnInit() {
    this.dialogRef.addPanelClass('confirm-parental-control-dialog');
  }

  ngOnViewInit() {
    if (!this.expiredTime()) {
      this.codeInputRef.focusOnField(0);
    }
  }

  onCodeChanged($event: any) {
    this.codeInput.patchValue($event);
  }

  onCodeCompleted($event: any) {
    this.codeInput.patchValue($event);
    this.submitCode();
  }

  handleExpiredTime($event: any) {
    if ($event) {
      this.expiredTime.set(true);
    }
  }

  resendCode() {
    this.userService.selectProfile(this.data.profileId).subscribe({
      next: (res) => {
        this.expiredTime.set(false);
        this.snackbar.showSnackbar(res.message!);
      },
    });
  }

  submitCode() {
    this.userService.confirmParentalCode(this.data.profileId, this.codeInput.value!).subscribe({
      next: (res) => {
        this.snackbar.showSnackbar(res.message!);
        if (res.statusCode === HttpStatusCode.Ok) {
          this.generalService.router.navigateByUrl('/');
          this.tokenService.setUserInfo(res.data?.atk!, res.data?.rtk!);
          this.dialogRef.close(true);
        } else {
          this.codeInputRef.reset();
          this.codeInput.reset();
        }
      },
      error: (e) => {
        this.dialogRef.close(false);
        this.snackbar.showSnackbar(e.networkError.message, SnackbarType.error);
      },
    });
  }
}
